export default "__VITE_ASSET__6cb6716b__"